import React from "react";
import TdsatSuccessIcon from '../../images/tdsatSuccess.svg';
import { Typography, Grid, Box } from "@material-ui/core";
import validateDateAndFormat from "utils/validateDateAndFormat";

const ListUnderObjectionSuccessScreen = ({activeCase}) => {
   
    return (
      <Box
        sx={{ flexGrow: 1 }}
        style={{ backgroundColor: "white", padding: "3rem", width: "100%" }}
      >
        <img src={TdsatSuccessIcon} />
        <Typography
          variant="h1"
          style={{ marginTop: "40px", marginBottom: "10px", fontSize: "2rem" }}
        >
					{(activeCase?.type === 'documents' && !activeCase?.register_with_defect) ? (
						'Document verified sucessfully'
					):(
						'Case has been transferred to CIS for further action'
					)}
        </Typography>
        <Grid
          justify="center"
          container
          style={{ marginTop: "40px", marginBottom: "10px" }}
        >
          <Typography variant="h1">Diary Number:&nbsp;</Typography>
          <Typography variant="h1" color="primary">
            {activeCase?.diary_number}
          </Typography>
        </Grid>
        <Grid justify="center" container>
          <Typography variant="h1">Date & Time:&nbsp;</Typography>
          <Typography variant="h1" color="primary">
            {validateDateAndFormat(
              activeCase?.list_under_objection_date_time || activeCase?.registration_date_time || null,
              "dd/MM/y | h:mm a"
            )}
          </Typography>
        </Grid>
      </Box>
    );
}

export default ListUnderObjectionSuccessScreen;